import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Nofound from '../views/Nofound.vue'
import Member from '../views/Member.vue'
import Award from '../components/award.vue'
import Apply from '../components/apply'
import Upgrade from '../components/upgrade'
import Declear from '../components/declear'
import DeclarRecord from '../components/DeclarRecord'
import Record from '../components/record'
import Performance from '../components/performance'
import News from '../components/news'
import word_1 from '../components/word/word_1'
import applymembership from '../components/Modal/applymembership.vue'
import Performancedeclaration from '../components/Modal/Performancedeclaration'
import Reviewrecords from '../components/Reviewrecords'
import Awardreview from '../components/Awardreview'
import prize from '../views/prize'
import gfprize from '../views/gfprize'
import uploadAppendix from '../components/uploadAppendix'
import AwardBatch from '../components/AwardBatch'
import Awardbatchcgf from '../components/AwardBatchcgf'
import AwardLogreview from '../components/AwardLogreview'
import Awardgfreview from '../components/Awardgfreview'
Vue.use(VueRouter)

const routes = [{
	path: '/',
	component: Login
}, {
	path: '/login',
	component: Login
},
{
	path: '/nofound',
	// route level code-splitting
	// this generates a separate chunk (about.[hash].js) for this route
	// which is lazy-loaded when the route is visited.
	component: Nofound
},
{
	path: '/word_1',
	component: word_1
},
{
	path: '/applymembership',
	component: applymembership
},
{
	path: '/Performancedeclaration',
	component: Performancedeclaration
},
{
	path: '/prize',
	component: prize,
	children:[
		{
			path: 'Reviewrecords',
			component: Reviewrecords
		},
		{
			path: 'Awardreview',
			component: Awardreview
		},
// 		{
// 			path: 'Awardbatch',
// 			component: AwardBatch
// 		},
// 		{
// 			path: 'Awardlogreview',
// 			component: AwardLogreview
// 		},
// 		{
// 			path: 'Awardgfreview',
// 			component: Awardgfreview
// 		},
		
	]
},
{
	path: '/gfprize',
	component: gfprize,
	children:[
		{
			path: 'Awardbatch',
			component: AwardBatch
		},
		{
			path: 'Awardbatchcgf',
			component: Awardbatchcgf
		},
		{
			path: 'Awardlogreview',
			component: AwardLogreview
		},
		{
			path: 'Awardgfreview',
			component: Awardgfreview
		},
		
	]
},
{
	path: '/member',
	component: Member,
	children: [
	{
		path: 'award',
		component: Award
	},
	{
		path: 'apply',
		component: Apply
	},
	{
		path: 'upgrade',
		component: Upgrade
	},
	{
		path: 'declear',
		component: Declear
	},
	{
		path: 'Declar_record',
		component: DeclarRecord
	},
	{
		path: 'uploadAppendix',
		component: uploadAppendix
	},
	{
		path: 'record',
		component: Record
	},
	{
		path: 'performance',
		component: Performance
	},
	{
		path: 'news',
		component: News
	},
	]
},
{
	path: '*', // 页面不存在的情况下会跳到404页面
	redirect: '/nofound',
	hidden: true
}
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}



const router = new VueRouter({
	routes
})

//路由导航守卫
router.beforeEach((to, from, next) => {
    if (window._hmt) {
        if (to.path) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }
	if (to.path == '/' || to.path == '/word_1') {
		next()
	} else {
		const tokenstr = window.localStorage.getItem('MANAGETOKEN')
		if (tokenstr == null) {
			next('/')
		}
	}
	next()
})

export default router
